// sideDrawer.styles.js
import styled from "@emotion/styled";
import { Drawer } from "antd";

export const StyledSideDrawer = styled(Drawer)``;

export const StyledTitle = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const StyledCloseIconContainer = styled.div`
    cursor: pointer;
    height: 24px;
`;
